import React from 'react';

const Maintenance = ({ title, sub_title, image_url }) => {
	return (
		<div>
			<div className="bg-white dark:bg-gray-900">
				<div className="py-8 md:py-16 px-4 mx-auto max-w-screen-xl">
					<div className="grid gap-8 items-center md:gap-12 md:grid-cols-12">
						<div className="col-span-6 text-center sm:mb-6 md:text-left md:mb-0">
							<h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-gray-900 sm:text-5xl xl:text-6xl dark:text-white">
								{title}
							</h1>
							<p className="mx-auto max-w-xl font-light text-gray-500 md:mx-0 xl:mb-8 sm:text-lg xl:text-xl dark:text-gray-400">
								{sub_title}
							</p>
						</div>
						<div className="hidden col-span-6 md:flex">
							<img src={image_url} alt="illustration" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Maintenance;
